import React from "react";
import { Box, Container, Typography } from "@mui/material";
import MainNavigation from "@/components/MainNavigation/MainNavigation";
import CardDataGrid from "@/components/DataGrid/CardDataGrid";

const Overview = () => {
  const columns = [
    {
      field: "ConnectionProfiles",
      headerName: "Connection Profiles",
      width: 230,
      headerClassName: "cell-semidetach-left",
      cellClassName: "cell-semidetach-left",
    },
    {
      field: "CustomerOrder",
      headerName: "Customer Order",
      width: 200,
      headerClassName: "cell-semidetach-right",
      cellClassName: "cell-semidetach-right",
    },
    {
      field: "OrderDate",
      headerName: "Order Date",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "ConfirmedOrder",
      headerName: "Purchase Order No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "ERPOrder",
      headerName: "ERP Sales Order No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "ShipmentCode",
      headerName: "Shipment No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "WarehouseShipmentCode",
      headerName: "Warehouse Shipment No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "ERPShipmentCode",
      headerName: "ERP Shipment No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
    {
      field: "InvoiceCode",
      headerName: "Invoice No.",
      width: 180,
      headerClassName: "cell-detached",
      cellClassName: "cell-detached",
    },
  ];

  const rows = [
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E3D",
      ConnectionProfiles: "Walmart USA",
      CustomerOrder: "5469823454",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "PO0000000001",
      ERPOrder: "ORD000000001",
      ERPShipmentCode: "SH0000000001",
      ShipmentCode: "SH0000000001",
      InvoiceCode: "INV000000001",
      message: "hardcoded test : text text",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E3E",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000589",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "PO0000000002",
      ERPOrder: "ORD000000002",
      InvoiceCode: "INV000000002",
      message: "hardcoded test",
    },
    {
      id: "B9184FE5-11C3-4B3C-89AB-2144F9CB85D2",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000778",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "PO0000000003",
      ERPOrder: "ORD000000003",
      ShipmentCode: "SH0000000004",
      InvoiceCode: "INV000000004",
      message: "hardcoded test",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E31",
      ConnectionProfiles: "Walmart USA",
      CustomerOrder: "5469823454",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "PO0000000004",
      ERPOrder: "ORD000000004",
      message: "hardcoded test : text text",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E32",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000589",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "PO0000000005",
      message: "hardcoded test",
    },
    {
      id: "B9184FE5-11C3-4B3C-89AB-2144F9CB85D3",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000778",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000003",
      message: "hardcoded test",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E34",
      ConnectionProfiles: "Walmart USA",
      CustomerOrder: "5469823454",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000001",
      message: "hardcoded test : text text",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E35",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000589",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000002",
      message: "hardcoded test",
    },
    {
      id: "B9184FE5-11C3-4B3C-89AB-2144F9CB85D6",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000778",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000003",
      message: "hardcoded test",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E37",
      ConnectionProfiles: "Walmart USA",
      CustomerOrder: "5469823454",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000001",
      message: "hardcoded test : text text",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E38",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000589",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000002",
      message: "hardcoded test",
    },
    {
      id: "B9184FE5-11C3-4B3C-89AB-2144F9CB85D9",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000778",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000003",
      message: "hardcoded test",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E41",
      ConnectionProfiles: "Walmart USA",
      CustomerOrder: "5469823454",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000001",
      message: "hardcoded test : text text",
    },
    {
      id: "75E52F1F-8274-488B-8C17-182A20025E42",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000589",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000002",
      message: "hardcoded test",
    },
    {
      id: "B9184FE5-11C3-4B3C-89AB-2144F9CB8543",
      ConnectionProfiles: "Amazon USA",
      CustomerOrder: "1234-000778",
      OrderDate: "2023-04-20",
      ConfirmedOrder: "ORD000000003",
      message: "hardcoded test",
    },
  ];
  return (
    <Container>
      <MainNavigation selected="Overview" />
      <Box
        className="content-container"
        style={{
          maxWidth: 1780,
        }}
      >
        <Typography variant="h1" className="page-header">
          Customer Order Lifecycle (Page is deprecated)
        </Typography>
        <CardDataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pinnedColumns: {
              left: ["ConnectionProfiles", "CustomerOrder", "OrderDate"],
            },
          }}
          pinnedGapCount={2}
          whiteHeader={false}
        />
      </Box>
    </Container>
  );
};

export default Overview;
